function mtInitReveal() {
  const els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach((el) => el.classList.add('mt-visible'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach((el) => io.observe(el));
}

function mtInitContadores() {
  const els = document.querySelectorAll('.mt-num[data-target]');
  if (!els.length) return;
  const animar = (el) => {
    const target = parseFloat(el.dataset.target);
    const decimales = el.dataset.target.includes('.') ? 1 : 0;
    const duracion = 1400;
    const inicio = performance.now();
    function paso(ahora) {
      const progreso = Math.min((ahora - inicio) / duracion, 1);
      const valor = target * (1 - Math.pow(1 - progreso, 3));
      el.textContent = valor.toFixed(decimales);
      if (progreso < 1) requestAnimationFrame(paso);
      else el.textContent = target.toFixed(decimales);
    }
    requestAnimationFrame(paso);
  };
  if (!('IntersectionObserver' in window)) {
    els.forEach(animar);
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animar(entry.target);
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.4 }
  );
  els.forEach((el) => io.observe(el));
}

function mtInitGaleriaProducto() {
  const galerias = document.querySelectorAll('[data-mt-galeria]');
  galerias.forEach((galeria) => {
    const principal = galeria.querySelector('[data-mt-imagen-principal]');
    const minis = galeria.querySelectorAll('[data-mt-mini]');
    if (!principal || !minis.length) return;
    minis.forEach((mini) => {
      mini.addEventListener('click', () => {
        const src = mini.dataset.mtMini;
        principal.src = src;
        minis.forEach((m) => m.classList.remove('mt-mini-activa'));
        mini.classList.add('mt-mini-activa');
      });
    });
  });
}

function mtInitVariantes() {
  const forms = document.querySelectorAll('.mt-producto-form');
  forms.forEach((form) => {
    const selects = form.querySelectorAll('[data-mt-opcion]');
    const idInput = form.querySelector('input[name="id"]');
    const precioEl = form.querySelector('[data-mt-precio]');
    const compareEl = form.querySelector('[data-mt-precio-comparado]');
    const botonEl = form.querySelector('[data-mt-boton-comprar]');
    const dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!selects.length || !idInput || !dataEl) return;
    let variantes = [];
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    function actualizar() {
      const valores = Array.from(selects).map((s) => s.value);
      const variante = variantes.find((v) => v.options.every((opt, i) => opt === valores[i]));
      if (!variante) return;
      idInput.value = variante.id;
      if (precioEl) precioEl.textContent = variante.precioFormateado;
      if (compareEl) {
        if (variante.compareFormateado) {
          compareEl.textContent = variante.compareFormateado;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (botonEl) {
        if (variante.disponible) {
          botonEl.disabled = false;
          botonEl.textContent = botonEl.dataset.textoDisponible;
        } else {
          botonEl.disabled = true;
          botonEl.textContent = botonEl.dataset.textoAgotado;
        }
      }
    }
    selects.forEach((s) => s.addEventListener('change', actualizar));
    actualizar();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  mtInitReveal();
  mtInitContadores();
  mtInitGaleriaProducto();
  mtInitVariantes();
});
